<template>
  <v-card class="pa-6">
    <v-form ref="form">
      <IndustrialPropertyFields :industrial-property="item" @update="updateField" />
      <template v-if="editing">
        <v-divider class="mt-6 mb-5" />
        <IndustrialPropertyFiles :id="item.id" final />
      </template>
      <div class="text-center mt-6">
        <v-btn text @click="$router.back()"><v-icon left>mdi-arrow-left</v-icon>{{ $t("button.back") }}</v-btn>
        <v-btn color="primary" class="ml-2" @click="save"><v-icon left>mdi-content-save</v-icon>{{ $t("button.save") }}</v-btn>
      </div>
    </v-form>
  </v-card>
</template>
<script>
import axios from "axios";
import IndustrialPropertyFields from "@/components/industrialProperty/IndustrialPropertyFields.vue";
import IndustrialPropertyFiles from "@/components/industrialProperty/IndustrialPropertyFiles.vue";
import {
  createDefaultIndustrialProperty,
  normalizeIndustrialProperty,
  serializeIndustrialProperty
} from "@/utils/industrialProperty";

export default {
  name: "EditIndustrialPropertyDetail",
  components: { IndustrialPropertyFields, IndustrialPropertyFiles },
  data: () => ({ item: createDefaultIndustrialProperty() }),
  computed: { editing() { return this.$route.params.id > -1; } },
  created() {
    if (this.editing) {
      axios.get(`${this.$store.state.endpoint}/industrial_property/${this.$route.params.id}`)
        .then(response => { this.item = normalizeIndustrialProperty(response.data); })
        .catch(error => console.error(error));
    }
  },
  methods: {
    updateField(field, value) { this.$set(this.item, field, value); },
    save() {
      if (!this.$refs.form.validate()) return;
      axios({
        method: this.editing ? "patch" : "post",
        url: this.editing
          ? `${this.$store.state.endpoint}/industrial_property/${this.$route.params.id}`
          : `${this.$store.state.endpoint}/industrial_property`,
        data: serializeIndustrialProperty(this.item)
      }).then(response => {
        this.$store.commit("alert", {
          color: "success",
          text: this.$t(this.editing ? "message.correct.updateItem" : "message.correct.createItem")
        });
        if (!this.editing) this.$router.push(`/manage/edit/industrialProperties/edit/${response.data.id}`);
      }).catch(error => this.$store.commit("alert", {
        color: "error", text: error.response ? error.response.data : error.message
      }));
    }
  }
};
</script>
